import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addResourcesRequest = {};
var _addResourcesResponse = {};
var _benefit = { creditAmount: 'google.protobuf.DoubleValue' };
var _benefitWithPlanInfo = { benefit: '_benefit' };
var _bulkDeleteResourcesRequest = {};
var _bulkDeleteResourcesResponse = {};
var _createPlanBenefitsRequest = { benefits: '_benefit' };
var _createPlanBenefitsResponse = { benefits: '_benefit' };
var _deletePlanBenefitsRequest = {};
var _deletePlanBenefitsResponse = {};
var _deleteResourcesRequest = {};
var _deleteResourcesResponse = {};
var _listRequest = {};
var _listResponse = { benefitsWithPlanInfo: '_benefitWithPlanInfo' };
var _updateBenefitsRequest = { benefits: '_benefit' };
var _updateBenefitsResponse = {};
var _updatePlanBenefitsRequest = { benefits: '_benefit' };
var _updatePlanBenefitsResponse = {};
function resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/entitlements-proxy-management',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        'vod-server._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        '*.wixapps.net': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        _: [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/pricing-plan-benefits/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/plans',
                destPath: '/v2/plans',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/resources',
                destPath: '/v2/resources',
            },
            {
                srcPath: '/_api/pricing-plan-benefits-server/v2/delete-resources',
                destPath: '/v2/delete-resources',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Create benefits for a single plan */
export function createPlanBenefits(payload) {
    var _a = serializer(_createPlanBenefitsRequest, { _benefit: _benefit }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createPlanBenefitsResponse, {
        _benefit: _benefit,
    }).fromJSON;
    function __createPlanBenefits(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.benefit',
            method: 'POST',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.BenefitManagement.CreatePlanBenefits',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl({
                protoPath: '/v2/plans/{planId}/benefits',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createPlanBenefits.fromReq = fromReq;
    __createPlanBenefits.__isAmbassador = true;
    return __createPlanBenefits;
}
/** Update benefits for a single plan, removes the existing benefits, and sets the given set of benefits */
export function updatePlanBenefits(payload) {
    var _a = serializer(_updatePlanBenefitsRequest, { _benefit: _benefit }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePlanBenefitsResponse, {}).fromJSON;
    function __updatePlanBenefits(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.benefit',
            method: 'PUT',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.BenefitManagement.UpdatePlanBenefits',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl({
                protoPath: '/v2/plans/{planId}/benefits',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePlanBenefits.fromReq = fromReq;
    __updatePlanBenefits.__isAmbassador = true;
    return __updatePlanBenefits;
}
/** Delete benefits for a single plan */
export function deletePlanBenefits(payload) {
    var _a = serializer(_deletePlanBenefitsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deletePlanBenefitsResponse, {}).fromJSON;
    function __deletePlanBenefits(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.benefit',
            method: 'POST',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.BenefitManagement.DeletePlanBenefits',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl({
                protoPath: '/v2/plans/{planId}/delete-benefits',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deletePlanBenefits.fromReq = fromReq;
    __deletePlanBenefits.__isAmbassador = true;
    return __deletePlanBenefits;
}
/** Updates existing benefits for a single plan */
export function update(payload) {
    var _a = serializer(_updateBenefitsRequest, { _benefit: _benefit }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBenefitsResponse, {}).fromJSON;
    function __update(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.benefit',
            method: 'PUT',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.BenefitManagement.Update',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl({
                protoPath: '/v2/plans/{planId}/benefits/overwrite',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __update.fromReq = fromReq;
    __update.__isAmbassador = true;
    return __update;
}
/** Gets benefits for all plans */
export function list(payload) {
    var _a = serializer(_listRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listResponse, {
        _benefit: _benefit,
        _benefitWithPlanInfo: _benefitWithPlanInfo,
    }).fromJSON;
    function __list(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.benefit',
            method: 'GET',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.BenefitManagement.List',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl({
                protoPath: '/v2/plans/benefits',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __list.fromReq = fromReq;
    __list.__isAmbassador = true;
    return __list;
}
/** Add resources to specific benefits */
export function addResources(payload) {
    var _a = serializer(_addResourcesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addResourcesResponse, {}).fromJSON;
    function __addResources(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.benefit',
            method: 'POST',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.BenefitManagement.AddResources',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl({
                protoPath: '/v2/plans/benefits/resources',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addResources.fromReq = fromReq;
    __addResources.__isAmbassador = true;
    return __addResources;
}
/** Delete resources from specific benefits or all benefits */
export function deleteResources(payload) {
    var _a = serializer(_deleteResourcesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteResourcesResponse, {}).fromJSON;
    function __deleteResources(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.benefit',
            method: 'POST',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.BenefitManagement.DeleteResources',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl({
                protoPath: '/v2/delete-resources',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteResources.fromReq = fromReq;
    __deleteResources.__isAmbassador = true;
    return __deleteResources;
}
/** Delete bulk of specific resources of specific benefits */
export function bulkDeleteResources(payload) {
    var _a = serializer(_bulkDeleteResourcesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteResourcesResponse, {}).fromJSON;
    function __bulkDeleteResources(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.pricing_plans.v2.benefit',
            method: 'DELETE',
            methodFqn: 'com.wix.pricingplans.benefits.api.v2.BenefitManagement.BulkDeleteResources',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixPricingplansBenefitsApiV2BenefitManagementUrl({
                protoPath: '/v2/plans/benefits/resources',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteResources.fromReq = fromReq;
    __bulkDeleteResources.__isAmbassador = true;
    return __bulkDeleteResources;
}
//# sourceMappingURL=http.impl.js.map